// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./settings.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../styles/typography.css";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../styles/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2016, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

.Tandem--header--whs3N {
  display: flex;
  justify-content: space-between;

  align-items: center;
  align-content: center;
}

.Tandem--headerCommon--oS2Oj {
  line-height: 20px;
}

.Tandem--basalScheduleHeader--njyr8 {
}

.Tandem--bolusSettingsHeader--M8ET5 {
}

.Tandem--collapsibleLabel--qHk8e {
  border-top: 1px solid var(--collapsible--border);
  justify-content: flex-start;
  line-height: 40px;
  margin-left: 20px;
  padding-left: 1em;
}

.Tandem--profileTable--OCxjI {
  padding-bottom: 1em;
  margin-left: 40px;
  width: auto;
}

.Tandem--profileTable--OCxjI td, .Tandem--profileTable--OCxjI th {
  font-size: 14px;
  text-align: center;
}

.Tandem--profileTable--OCxjI thead th {
  padding-left: 24px;
  padding-right: 10px;
}

.Tandem--profileTable--OCxjI thead th:first-child {
  text-align: left;
  padding-left: 10px;
  padding-right: 10px;
}

.Tandem--profileTable--OCxjI th:first-of-type {
  font-weight: bold;
}

.Tandem--title--Jm4xp {
  display: inline-block;
  padding-bottom: 10px;
}

.Tandem--categoryTitle--jwXEy {
  width: 100%;
  padding-bottom: 10px;
  margin-left: 40px;
  margin-top: 15px;
}

.Tandem--settingsTableInverted--CYr53 {
  margin-bottom: 1em;
  margin-left: 40px;
  width: 25%;
  min-width: 240px;
}

.Tandem--settingsTableInverted--CYr53 td:first-child, .Tandem--settingsTableInverted--CYr53 th:first-child {
  /* padding-left: 28px; */
  padding-left: 14px;
}

.Tandem--insulinSettingsHeader--jLGyj {
}

.Tandem--annotations--AD1l3 {
  margin-left: 40px;
  margin-right: 40px;
  margin-top: 30px;
  font-size: 14px;
  font-weight: 500;
}

@media print {

  .Tandem--title--Jm4xp {
    font-weight: normal;
    font-size: 20px;
    color: var(--text-black);
    display: inline-block;
    padding-bottom: 10px;
  }

  .Tandem--profileTable--OCxjI th {
    font-weight: normal;
    color: #000;
  }

  .Tandem--profileTable--OCxjI th:first-of-type {
    font-weight: normal;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/settings/Tandem.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAIF;EACE,aAAa;EACb,8BAA8B;;EAE9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;AAGA;;AAEA;AAGA;;AAEA;EACE,gDAAgD;EAChD,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EAEE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EAEE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;AAEA;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE;IACE,mBAAmB;IACnB,eAAe;IACf,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2016, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n\n@import '../../styles/colors.css';\n\n.header {\n  display: flex;\n  justify-content: space-between;\n\n  align-items: center;\n  align-content: center;\n}\n\n.headerCommon {\n  line-height: 20px;\n}\n\n.basalScheduleHeader {\n  composes: basalHeaderBackground settingsHeaderText from './settings.css';\n  composes: headerCommon;\n}\n\n.bolusSettingsHeader {\n  composes: bolusHeaderBackground settingsHeaderText from './settings.css';\n  composes: headerCommon;\n}\n\n.collapsibleLabel {\n  border-top: 1px solid var(--collapsible--border);\n  justify-content: flex-start;\n  line-height: 40px;\n  margin-left: 20px;\n  padding-left: 1em;\n}\n\n.profileTable {\n  composes: basalTable from './settings.css';\n  padding-bottom: 1em;\n  margin-left: 40px;\n  width: auto;\n}\n\n.profileTable td, .profileTable th {\n  font-size: 14px;\n  text-align: center;\n}\n\n.profileTable thead th {\n  padding-left: 24px;\n  padding-right: 10px;\n}\n\n.profileTable thead th:first-child {\n  text-align: left;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.profileTable th:first-of-type {\n  font-weight: bold;\n}\n\n.title {\n  composes: boldText defaultSize mediumContrastText from '../../styles/typography.css';\n  display: inline-block;\n  padding-bottom: 10px;\n}\n\n.categoryTitle {\n  composes: mediumContrastText from '../../styles/typography.css';\n  width: 100%;\n  padding-bottom: 10px;\n  margin-left: 40px;\n  margin-top: 15px;\n}\n\n.settingsTableInverted {\n  composes: settingsTableInverted from './settings.css';\n  margin-bottom: 1em;\n  margin-left: 40px;\n  width: 25%;\n  min-width: 240px;\n}\n\n.settingsTableInverted td:first-child, .settingsTableInverted th:first-child {\n  /* padding-left: 28px; */\n  padding-left: 14px;\n}\n\n.insulinSettingsHeader {\n  composes: bolusHeaderBackground settingsHeader from './settings.css';\n}\n\n.annotations {\n  margin-left: 40px;\n  margin-right: 40px;\n  margin-top: 30px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n@media print {\n\n  .title {\n    font-weight: normal;\n    font-size: 20px;\n    color: var(--text-black);\n    display: inline-block;\n    padding-bottom: 10px;\n  }\n\n  .profileTable th {\n    font-weight: normal;\n    color: #000;\n  }\n\n  .profileTable th:first-of-type {\n    font-weight: normal;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Tandem--header--whs3N`,
	"headerCommon": `Tandem--headerCommon--oS2Oj`,
	"basalScheduleHeader": `Tandem--basalScheduleHeader--njyr8 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["basalHeaderBackground"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["settingsHeaderText"]} Tandem--headerCommon--oS2Oj`,
	"bolusSettingsHeader": `Tandem--bolusSettingsHeader--M8ET5 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bolusHeaderBackground"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["settingsHeaderText"]} Tandem--headerCommon--oS2Oj`,
	"collapsibleLabel": `Tandem--collapsibleLabel--qHk8e`,
	"profileTable": `Tandem--profileTable--OCxjI ${___CSS_LOADER_ICSS_IMPORT_0___.locals["basalTable"]}`,
	"title": `Tandem--title--Jm4xp ${___CSS_LOADER_ICSS_IMPORT_1___.locals["boldText"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["defaultSize"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["mediumContrastText"]}`,
	"categoryTitle": `Tandem--categoryTitle--jwXEy ${___CSS_LOADER_ICSS_IMPORT_1___.locals["mediumContrastText"]}`,
	"settingsTableInverted": `Tandem--settingsTableInverted--CYr53 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["settingsTableInverted"]}`,
	"insulinSettingsHeader": `Tandem--insulinSettingsHeader--jLGyj ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bolusHeaderBackground"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["settingsHeader"]}`,
	"annotations": `Tandem--annotations--AD1l3`
};
export default ___CSS_LOADER_EXPORT___;
